const lang = (id: number, short: string) => ({
  id,
  short,
});

export const locales = {
  English: lang(1, 'en'),
  Russian: lang(2, 'ru'),
  German: lang(3, 'de'),
  French: lang(4, 'fr'),
  Italian: lang(5, 'it'),
  Spanish: lang(6, 'es'),
  Portuguese: lang(7, 'pt'),
  Japanese: lang(9, 'ja'),
  Korean: lang(14, 'ko'),
  Chinese: lang(15, 'zh'),
  Turkish: lang(18, 'tr'),
  Poland: lang(19, 'pl'),
};

